<template>
    <div>
        <base-spinner v-if="isLoading"/>
        <base-page v-else>

            <div
                v-for="(previousSurgery, index) in patient.previous_surgeries"
                :key="index"
                class="my-3"
            >
                <b-card header-class="bar-color2 header-font">
                    <template v-slot:header>
                        {{ previousSurgery.type | choice(previousSurgeryFields.type) }}
                    </template>

                    <display-field
                        :field="previousSurgeryFields.number"
                        :value="previousSurgery.number"
                        value-class="form-value"
                    />
                    <display-array-field
                        :field="previousSurgeryFields.treatment"
                        :values="previousSurgery.treatment"
                        choices
                    />
                    <display-field
                        :field="previousSurgeryFields.note"
                        :value="previousSurgery.note"
                        value-class="form-value"
                    />
                </b-card>
            </div>

            <div v-if="!patient.previous_surgeries.length">
                {{ $t('previousSurgery.noPreviousSurgeries') }}
            </div>
        </base-page>
    </div>
</template>

<script>
    import {mapActions, mapState} from "vuex";
    import BasePageMixin from "@/components/BasePageMixin";
    import BasePage from "@/components/BasePage";
    import BaseSpinner from "@/components/BaseSpinner";
    import DisplayField from "@/components/DisplayField";
    import DisplayArrayField from "@/components/DisplayArrayField";

    export default {
        name: "ListPreviousSurgeryPage",
        components: {
            DisplayArrayField,
            DisplayField,
            BaseSpinner,
            BasePage,
        },
        mixins: [BasePageMixin],
        data() {
            return {
                isLoading: true,
                addingPreviousSurgery: false,
                editable: true,
            };
        },
        computed: {
            ...mapState(['patient', 'previousSurgeryFields']),
        },
        async created() {
            await this.getPreviousSurgeryOptions();
            this.isLoading = false;
        },
        methods: {
            ...mapActions(['getPreviousSurgeryOptions']),
            create() {
                this.addingPreviousSurgery = true;
                this.toggleEditable();
            },
            finishEditing() {
                this.addingPreviousSurgery = false;
                this.toggleEditable();
            },
            toggleEditable() {
                this.editable = !this.editable;
            },
            add() {
                this.previousSurgeries = this.previousSurgeries.concat([{
                    type: '',
                    number: null,
                    treatment: [],
                    note: '',
                }]);
            },
        },
    };
</script>

<style scoped>
    .header-font {
        font-weight: 600 !important;
    }
</style>